import React from 'react';
export var IconContext = /*#__PURE__*/React.createContext(null);
export var IconProvider = IconContext.Provider;
export var useIconContext = function useIconContext() {
  return React.useContext(IconContext);
};